export default {
  computed: {
    typeDefinitions() {
      return {
        text: {
          key: "text",
          text: this.$t("custom-fields.fields.text.label"),
          icon: "fa fa-text-height",
          description: this.$t("custom-fields.fields.text.description")
        },
        numeric: {
          key: "numeric",
          text: this.$t("custom-fields.fields.numeric.label"),
          icon: "fa fa-hashtag",
          description: this.$t("custom-fields.fields.numeric.description")
        },
        monetary: {
          key: "monetary",
          text: this.$t("custom-fields.fields.monetary.label"),
          icon: "fa fa-usd",
          description: this.$t("custom-fields.fields.monetary.description")
        },
        phone: {
          key: "phone",
          text: this.$t("custom-fields.fields.phone.label"),
          icon: "fa fa-phone",
          description: this.$t("custom-fields.fields.phone.description")
        },
        date: {
          key: "date",
          text: this.$t("custom-fields.fields.date.label"),
          icon: "fa fa-calendar custom-field-calendar text-primary",
          description: this.$t("custom-fields.fields.date.description")
        },
        address: {
          key: "address",
          text: this.$t("custom-fields.fields.address.label"),
          icon: "fa fa-map-marker",
          description: this.$t("custom-fields.fields.address.description")
        },
        email: {
          key: "email",
          text: this.$t("custom-fields.fields.email.label"),
          icon: "fa fa-envelope",
          description: this.$t("custom-fields.fields.email.description")
        },
        dropdown: {
          key: "dropdown",
          text: this.$t("custom-fields.fields.dropdown.label"),
          icon: "fa fa-caret-square-o-down",
          description: this.$t("custom-fields.fields.dropdown.description")
        }
      };
    }
  },
  methods: {}
};